import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../base.component";
import * as gsap from "gsap";
import {RouteUtil} from "../../util/route.util";
import {isPlatformBrowser} from "@angular/common";
import {Config} from "../../common/config";

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent extends BaseComponent implements OnInit {
  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    if (isPlatformBrowser(Config.platformId)) {
      gsap.gsap.set("svg", {visibility: "visible"});
      gsap.gsap.to("#headStripe", {
        y: 0.5,
        rotation: 1,
        yoyo: true,
        repeat: -1,
        ease: "sine.inOut",
        duration: 1
      });
      gsap.gsap.to("#spaceman", {
        y: 0.5,
        rotation: 1,
        yoyo: true,
        repeat: -1,
        ease: "sine.inOut",
        duration: 1
      });
      gsap.gsap.to("#craterSmall", {
        x: -3,
        yoyo: true,
        repeat: -1,
        duration: 1,
        ease: "sine.inOut"
      });
      gsap.gsap.to("#craterBig", {
        x: 3,
        yoyo: true,
        repeat: -1,
        duration: 1,
        ease: "sine.inOut"
      });
      gsap.gsap.to("#planet", {
        rotation: -2,
        yoyo: true,
        repeat: -1,
        duration: 1,
        ease: "sine.inOut",
        transformOrigin: "50% 50%"
      });
      gsap.gsap.to("#starsBig g", {
        rotation: "random(-30,30)",
        transformOrigin: "50% 50%",
        yoyo: true,
        repeat: -1,
        ease: "sine.inOut"
      });
      gsap.gsap.fromTo(
        "#starsSmall g",
        {
          scale: 0,
          transformOrigin: "50% 50%"
        },
        {
          scale: 1,
          transformOrigin: "50% 50%",
          yoyo: true,
          repeat: -1,
          stagger: 0.1
        }
      );
      gsap.gsap.to("#circlesSmall circle", {
        y: -4,
        yoyo: true,
        duration: 1,
        ease: "sine.inOut",
        repeat: -1
      });
      gsap.gsap.to("#circlesBig circle", {
        y: -2,
        yoyo: true,
        duration: 1,
        ease: "sine.inOut",
        repeat: -1
      });
      gsap.gsap.set("#glassShine", {x: -68});
      gsap.gsap.to("#glassShine", {
        x: 80,
        duration: 2,
        rotation: -30,
        ease: "expo.inOut",
        transformOrigin: "50% 50%",
        repeat: -1,
        repeatDelay: 8,
        delay: 2
      });
    }
  }

  onHomeClicked() {
    this.router.navigate([RouteUtil.COMMON_MODULE]).then();
  }
}
